const marka = { t: 'Marka', name: 'marka', hint: { url: '/make/agri' }}
export default marka